import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Breadcrumb, BreadcrumbDivider, BreadcrumbItem, Hamburger, makeStyles, Text, Tooltip, tokens, } from '@fluentui/react-components';
import { useLocation } from 'react-router';
import { useAppConfig } from '#src/app/app-config.js';
import { findRoute } from '#src/app/navigation/navigation.js';
import { UserMenu } from '#src/app/shell/UserMenu.js';
const useStyles = makeStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        gap: tokens.spacingHorizontalS,
        height: '48px',
        padding: `0 ${tokens.spacingHorizontalXXL} 0 ${tokens.spacingHorizontalXXXL}`,
        flexShrink: 0,
    },
    trail: { flexGrow: 1, minWidth: 0 },
    module: { color: tokens.colorNeutralForeground3 },
});
function trailOf(modules, pathname) {
    const route = findRoute(modules, pathname);
    if (route === undefined) {
        return { current: 'Início' };
    }
    const { module, page, route: subRoute } = route;
    if (subRoute !== undefined) {
        return { module: module.title, current: subRoute.title };
    }
    if (page === undefined || module.pages.length === 1) {
        return { current: module.title };
    }
    return { module: module.title, current: page.title };
}
export function TopBar({ showMenu, onOpenMenu, }) {
    const styles = useStyles();
    const trail = trailOf(useAppConfig().modules, useLocation().pathname);
    return (_jsxs("header", { className: styles.root, children: [showMenu && (_jsx(Tooltip, { content: "Abrir navega\u00E7\u00E3o", relationship: "label", children: _jsx(Hamburger, { onClick: onOpenMenu }) })), _jsxs(Breadcrumb, { className: styles.trail, "aria-label": "Voc\u00EA est\u00E1 em", children: [trail.module !== undefined && (_jsxs(_Fragment, { children: [_jsx(BreadcrumbItem, { children: _jsx(Text, { className: styles.module, children: trail.module }) }), _jsx(BreadcrumbDivider, {})] })), _jsx(BreadcrumbItem, { children: _jsx(Text, { weight: "semibold", "aria-current": "page", children: trail.current }) })] }), _jsx(UserMenu, {})] }));
}
//# sourceMappingURL=TopBar.js.map